module.exports = __webpack_public_path__ + "static/img/base_8.db1996f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/base_8.jpg
// module id = ORcv
// module chunks = 1